export default [
  { name: 'European Union', code: 'EU' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
];
